import React, { useEffect, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useTransition, animated } from 'react-spring';
import { FaArrowCircleUp, FaAngleDoubleLeft, FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import NavbarDetailBlog from '../../../components/navbarDetailBlog.tsx';
import HeaderDetailBlog from '../utils/headerDetailBlog.tsx';
import Footer from '../../../components/footer.tsx';
import { Link } from 'react-router-dom';
import ImageModal from '../utils/imageModal.tsx';


import usePreventZoom from '../../../preventZoom.js';

import Header from '../../../assets/Blog/ACL/ACL_PART9/Detail/HEADER_DETAIL_ACL_PART9.webp';
import Pict1 from "../../../assets/Blog/ACL/ACL_PART9/Detail/1.webp";
import Pict2 from "../../../assets/Blog/ACL/ACL_PART9/Detail/2.webp";
import Pict3 from "../../../assets/Blog/ACL/ACL_PART9/Detail/3.webp";
import Pict4 from "../../../assets/Blog/ACL/ACL_PART9/Detail/4.webp";
import Pict5 from "../../../assets/Blog/ACL/ACL_PART9/Detail/5.webp";
import Pict6 from "../../../assets/Blog/ACL/ACL_PART9/Detail/6.webp";
import Pict7 from "../../../assets/Blog/ACL/ACL_PART9/Detail/7.webp";

import Gallery1 from "../../../assets/Blog/ACL/ACL_PART9/Detail/8.webp";
import Gallery2 from "../../../assets/Blog/ACL/ACL_PART9/Detail/9.webp";
import Gallery3 from "../../../assets/Blog/ACL/ACL_PART9/Detail/10.webp";
import Gallery4 from "../../../assets/Blog/ACL/ACL_PART9/Detail/11.webp";
import Gallery5 from "../../../assets/Blog/ACL/ACL_PART9/Detail/12.webp";
import Gallery6 from "../../../assets/Blog/ACL/ACL_PART9/Detail/13.webp";
import Gallery7 from "../../../assets/Blog/ACL/ACL_PART9/Detail/14.webp";
import Gallery8 from "../../../assets/Blog/ACL/ACL_PART9/Detail/15.webp";
import Gallery9 from "../../../assets/Blog/ACL/ACL_PART9/Detail/16.webp";
import Gallery10 from "../../../assets/Blog/ACL/ACL_PART9/Detail/17.webp";
import Gallery11 from "../../../assets/Blog/ACL/ACL_PART9/Detail/18.webp";
import Gallery12 from "../../../assets/Blog/ACL/ACL_PART9/Detail/19.webp";
import Gallery13 from "../../../assets/Blog/ACL/ACL_PART9/Detail/20.webp";
import Gallery14 from "../../../assets/Blog/ACL/ACL_PART9/Detail/21.webp";
import Gallery15 from "../../../assets/Blog/ACL/ACL_PART9/Detail/22.webp";
import Gallery16 from "../../../assets/Blog/ACL/ACL_PART9/Detail/23.webp";
import Gallery17 from "../../../assets/Blog/ACL/ACL_PART9/Detail/24.webp";
import Gallery18 from "../../../assets/Blog/ACL/ACL_PART9/Detail/25.webp";
import Gallery19 from "../../../assets/Blog/ACL/ACL_PART9/Detail/26.webp";
import Gallery20 from "../../../assets/Blog/ACL/ACL_PART9/Detail/27.webp";
import Gallery21 from "../../../assets/Blog/ACL/ACL_PART9/Detail/28.webp";
import Gallery22 from "../../../assets/Blog/ACL/ACL_PART9/Detail/29.webp";
import Gallery23 from "../../../assets/Blog/ACL/ACL_PART9/Detail/30.webp";
import Gallery24 from "../../../assets/Blog/ACL/ACL_PART9/Detail/31.webp";
import Gallery25 from "../../../assets/Blog/ACL/ACL_PART9/Detail/32.webp";
import Gallery26 from "../../../assets/Blog/ACL/ACL_PART9/Detail/33.webp";
import Gallery27 from "../../../assets/Blog/ACL/ACL_PART9/Detail/34.webp";

import CommentListExample from '../../../components/comments/commentListExample.tsx';

const ACLPART9: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 900px)').matches);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedAlt, setSelectedAlt] = useState('');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(30);
        setTimeout(() => {
            setProgress(100);
        }, 600);
    }, []);
  
    const openModal = (imageUrl, imageAlt) => {
        setSelectedImage(imageUrl);
        setSelectedAlt(imageAlt);
        setModalVisible(true);
    };
  
    const closeModal = () => {
        setSelectedImage('');
        setSelectedAlt('');
        setModalVisible(false);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 900px)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 350) {
            setShowScrollToTop(true);
        } else {
            setShowScrollToTop(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const arrowTransition = useTransition(showScrollToTop, {
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(100%)' },
        config: { tension: 300, friction: 20 },
      });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: false});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    usePreventZoom();

    return(
        <div className='App'>
            <NavbarDetailBlog/>
            <div className='pt-20 min-w-screen font-condensed text-textGrey'>
                {/* Loading Bar */}
                <LoadingBar color="#8C001f" progress={progress} onLoaderFinished={() => setProgress(0)} />
                <section className='hidden w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'>
                        <script type='text/javascript' id='mapmyvisitors' src='https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff'></script>
                </section>
                <HeaderDetailBlog backgroundImage={Header} title="Back to Indonesia (Part 9)" date="3" year="August, 2025" backgroundPosition="center bottom"></HeaderDetailBlog>
                <div className='author-article text-end pr-4 pt-8 pb-4 text-xs'>
                    <p className='font-condensed text-textGrey'>by Mohammad Rifqi Farhansyah | Association for Computational Linguistics 2025</p>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict1, 'Photo while waiting for departure at Zurich Airport.')}>
                            <img
                                src={Pict1}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo while waiting for departure at Zurich Airport."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo while waiting for departure at Zurich Airport.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich Airport, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-2xl'>Europe is indeed wonderful, but in my heart, it will always be Indonesia. Nothing can replace it.</p>
                        <br/>
                        <p className='text-lg'>
                            After finishing all the check-in process, I was just waiting for my flight to depart. I would be flying with Swiss Airlines to Suvarnabhumi Airport in Bangkok, Thailand, and then continue on to Soekarno-Hatta Airport in Indonesia. At the airport, I did not buy anything, because I knew everything was expensive, and I had already bought Swiss chocolate earlier as souvenirs. I also did not wait for too long at the airport. After walking around Zurich earlier, I went straight to the restroom to freshen up, checked in, and only waited about 30 minutes before the plane was ready to board.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict2, 'Inside the Swiss Airlines cabin.')}>
                            <img
                                src={Pict2}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Inside the Swiss Airlines cabin."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Inside the Swiss Airlines cabin.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            The plane took off, and I was seated in an aisle seat this time, not a window seat anymore, hehe. Sitting next to me was a family consisting of a father, a mother, and their child. During the flight, we were served quite delicious food, especially the chocolate, which tasted very authentically Swiss. One thing that surprised me was that the woman sitting next to me finished around two bottles of wine in just a quarter of the flight, while calmly reading a book with her thick glasses on. Even though she was already quite old, she seemed very used to drinking wine. In my imagination, it must taste awful. After enjoying the food, I immediately fell asleep because I was exhausted from walking around earlier.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Crossing continents and the borders of dreams.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Header})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict3, 'A statue at Suvarnabhumi Airport.')}>
                            <img
                                src={Pict3}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A statue at Suvarnabhumi Airport."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A statue at Suvarnabhumi Airport.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Suvarnabhumi Airport, Thailand</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            I arrived at Suvarnabhumi Airport in Bangkok. Unfortunately, I only had a three-hour transit in Thailand, so there was not enough time to go outside. Thailand is actually one of the countries I really want to explore, especially because of a sport I like, Muay Thai. If I could stay there for just one day, and if it happened to be ONE Friday Nights, I would definitely go watch it at Lumpinee Stadium. But it is okay, maybe next time.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            At the airport, I just cleaned myself up after such a long journey, around 19 hours in total. After that, I unexpectedly met another Indonesian in front of the departure gate. He was a seafarer who had also just flown from Europe, specifically Paris. He is from around Nganjuk, East Java. He said he was going home because his wife was about to give birth. I really hope his wife and baby are healthy and everything goes smoothly. Congratulations on becoming a father.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict4, 'A blurry view through the airplane window during the delay.')}>
                            <img
                                src={Pict4}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A blurry view through the airplane window during the delay."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A blurry view through the airplane window during the delay.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Suvarnabhumi Airport, Thailand</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            We were asked to queue at the gate and board the plane. Before boarding, I realized that there was a well-known Indonesian actress on the same flight, Maudi Effrosina. But I did not dare to ask for a photo or even say hi. It felt a bit awkward, especially after such a long journey, and I did not want to risk making anyone uncomfortable. After boarding, the plane did not take off immediately. Fifteen minutes passed, then thirty minutes, then more than an hour. The plane was still not moving. Outside, I could see technicians trying to fix something. Finally, after about one and a half hours of waiting, the plane took off. I calculated that I would probably arrive in Indonesia at night.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict5, 'A sea of clouds outside the airplane window.')}>
                            <img
                                src={Pict5}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A sea of clouds outside the airplane window."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A sea of clouds outside the airplane window.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi </i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            On the flight back to Indonesia, the weather was very clear, and the clouds looked beautiful from the window. Sitting next to me was a mother and her daughter. We did not interact much. I mostly watched movies and listened to music on my phone. I chose fried rice for my meal, and for drinks, as usual, apple juice. On flights like this, I almost always ask for apple juice with ice, sometimes even asking for refills several times. Drinking milk makes me feel nauseous, alcohol is obviously not an option, and hot drinks are not very comfortable for me. After about three hours, the sky slowly turned dark.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Home sweet home.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Pict3})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict6, 'Arrival at Terminal 3, Soekarno-Hatta Airport.')}>
                            <img
                                src={Pict6}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Arrival at Terminal 3, Soekarno-Hatta Airport."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Arrival at Terminal 3, Soekarno-Hatta Airport.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Soekarno-Hatta Airport, Indonesia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            Alhamdulillah, I finally arrived in Indonesia. I waited for my suitcase, and a few moments later it appeared. I quickly grabbed it and prepared to go home. I planned to take a DAMRI bus to Gambir Station, then continue by train to Bandung Station to return to my boarding house. The DAMRI bus arrived and took me to Gambir Station. I had already bought my train ticket to Bandung earlier, and the departure was still about one hour away. So I decided to eat first at one of the food stalls in Gambir Station. After eating, I went straight to the platform where my train would arrive. I got on the train, put on my earbuds, eye mask, and immediately fell asleep.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict7, 'A photo of me on the Jakarta–Bandung train.')}>
                            <img
                                src={Pict7}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of me on the Jakarta–Bandung train."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of me on the Jakarta–Bandung train.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After the three-hour journey, I woke up right as the train arrived at Bandung Station. I took off my eye mask, grabbed my bag and suitcase, and went home. When I arrived at my boarding house, I realized something terrible. One side of my earbuds was missing. I suspected it fell somewhere inside the train carriage. I immediately went back to Bandung Station to look for it and reported it to the lost and found office. They said they would contact me later. I then went back to my boarding house because there was nothing else I could do. Before I even arrived, the staff I talked to earlier already informed me that the item was not found in the carriage and the case was closed. HMMMM, that was fast, KAI team V:. So in the end, I had to buy a replacement for the missing earbud, since it was not covered by warranty.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            And that is a small story of my journey attending the ACL conference, from departure until returning home. I hope there are some useful things you can take from this story. And if there are any bad things, please do not follow them. If there are any mistakes, I sincerely apologize. Thank you so much for reading :) see you in the next story.
                        </p>
                        <div className='article-break-1 flex justify-start items-center flex-col'>
                            <hr className='w-full mt-4 mb-4  border-t border-b border-solid'/>
                        </div>
                        <p className='text-lg font-bold'><i>THE END</i></p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-8 mb-4'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Muda berkelana, tua bercerita. (The world is a book, and those who do not travel read only one page.)
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery1, "Photo Recap: Back to Indonesia (Part 1).")}>
                        <img
                            src={Gallery1}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 1)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 1).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery2, "Photo Recap: Back to Indonesia (Part 2).")}>
                        <img
                            src={Gallery2}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 2)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 2).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery3, "Photo Recap: Back to Indonesia (Part 3).")}>
                        <img
                            src={Gallery3}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 3)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 3).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery4, "Photo Recap: Back to Indonesia (Part 4).")}>
                        <img
                            src={Gallery4}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 4)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 4).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery5, "Photo Recap: Back to Indonesia (Part 5).")}>
                        <img
                            src={Gallery5}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 5)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 5).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery6, "Photo Recap: Back to Indonesia (Part 6).")}>
                        <img
                            src={Gallery6}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 6)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 6).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery7, "Photo Recap: Back to Indonesia (Part 7).")}>
                        <img
                            src={Gallery7}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 7)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 7).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery8, "Photo Recap: Back to Indonesia (Part 8).")}>
                        <img
                            src={Gallery8}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 8)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 8).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery9, "Photo Recap: Back to Indonesia (Part 9).")}>
                        <img
                            src={Gallery9}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 9)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 9).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery10, "Photo Recap: Back to Indonesia (Part 10).")}>
                        <img
                            src={Gallery10}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 10)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 10).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery11, "Photo Recap: Back to Indonesia (Part 11).")}>
                        <img
                            src={Gallery11}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 11)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 11).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery12, "Photo Recap: Back to Indonesia (Part 12).")}>
                        <img
                            src={Gallery12}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 12)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 12).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery13, "Photo Recap: Back to Indonesia (Part 13).")}>
                        <img
                            src={Gallery13}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 13)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 13).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery14, "Photo Recap: Back to Indonesia (Part 14).")}>
                        <img
                            src={Gallery14}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 14)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 14).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery15, "Photo Recap: Back to Indonesia (Part 15).")}>
                        <img
                            src={Gallery15}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 15)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 15).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery16, "Photo Recap: Back to Indonesia (Part 16).")}>
                        <img
                            src={Gallery16}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 16)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 16).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery17, "Photo Recap: Back to Indonesia (Part 17).")}>
                        <img
                            src={Gallery17}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 17)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 17).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery18, "Photo Recap: Back to Indonesia (Part 18).")}>
                        <img
                            src={Gallery18}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 18)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 18).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery19, "Photo Recap: Back to Indonesia (Part 19).")}>
                        <img
                            src={Gallery19}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 19)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 19).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery20, "Photo Recap: Back to Indonesia (Part 20).")}>
                        <img
                            src={Gallery20}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 20)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 20).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery21, "Photo Recap: Back to Indonesia (Part 21).")}>
                        <img
                            src={Gallery21}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 21)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 21).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery22, "Photo Recap: Back to Indonesia (Part 22).")}>
                        <img
                            src={Gallery22}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 22)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 22).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery23, "Photo Recap: Back to Indonesia (Part 23).")}>
                        <img
                            src={Gallery23}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 23)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 23).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery24, "Photo Recap: Back to Indonesia (Part 24).")}>
                        <img
                            src={Gallery24}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 24)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 24).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery25, "Photo Recap: Back to Indonesia (Part 25).")}>
                        <img
                            src={Gallery25}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 25)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 25).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery26, "Photo Recap: Back to Indonesia (Part 26).")}>
                        <img
                            src={Gallery26}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 26)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 26).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery27, "Photo Recap: Back to Indonesia (Part 27).")}>
                        <img
                            src={Gallery27}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Back to Indonesia (Part 27)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Back to Indonesia (Part 27).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center px-12 md:mb-8 mb-4 gap-x-8'>
                <Link to="/acl/acl-part8" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    <FaAngleDoubleLeft className='w-3 h-3 text-textRed inline-block mr-1' />
                    PREV 
                </Link>
                <p className='md:text-xl text-lg text-textGrey font-bold flex items-center'>
                    NEXT 
                    <FaAngleDoubleRight className='w-3 h-3 text-textGrey inline-block ml-1' />
                </p>
            </div>
            <div className='bg-fixed w-full h-96' style={{ backgroundImage: `url(${Pict6})`, backgroundSize: 'cover',  }}>
            </div>
            <CommentListExample postId={9} seriesId={2}/>
            <ImageModal
                showModal={modalVisible}
                closeModal={closeModal}
                imageUrl={selectedImage}
                imageAlt={selectedAlt}
            />
            <Footer/>
            {arrowTransition((style, item) =>
                item ? (
                <animated.div
                    style={style}
                    className="fixed bottom-5 right-5 cursor-pointer z-10"
                    onClick={scrollToTop}
                >
                    <FaArrowCircleUp
                    size={isMd ? 32 : 24}
                    className="text-[#c0c5ca] hover:scale-110"
                    />
                </animated.div>
                ) : null
            )}
        </div>
    );
};

export default ACLPART9